import { render } from "./SkeletonLoader.vue?vue&type=template&id=22cb76b0&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=22cb76b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22cb76b0"]])

export default __exports__